









































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ZenObjectTable } from 'zenComponents';
import { BDropdownItemButton } from 'bootstrap-vue';
import { Vector, Score } from './types';
import EditColumn from '@/components/zen_components/zen_object_table/edit_column/EditColumn.vue';
import RowActions from '@/components/zen_components/zen_object_table/row_actions/RowActions.vue';
import { matchIds } from '@/utils';

export default Vue.extend({
  name: 'HeatmapTab',
  components: {
    ZenObjectTable,
    EditColumn,
    RowActions,
    BDropdownItemButton,
  },
  directives: {},
  props: {},
  data() {
    return {
      vectors: <Vector[]>[],
      items: <Score[]>[],
      loading: <boolean>true,
      columns: [
        { label: 'Risk Score', key: 'title' },
        { label: 'X-Axis Vector', key: 'heatmapX' },
        { label: 'Y-Axis Vector', key: 'heatmapY' },
        { label: '', key: 'actions' },
      ],
    };
  },
  computed: {
    ...mapGetters(['routes']),
  },
  async created() {
    this.vectors = (await this.fetchVectors()) || [];
    this.reloadScores();
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
      showModal: 'modals/show',
      request: 'request',
    }),
    async fetchVectors() {
      try {
        return await this.request({
          route: 'riskVectors',
          defaultErrorHandler: false,
        });
      } catch (e) {
        this.showAlert({
          type: 'error',
          message: 'Failed to load Risk Vectors',
        });
      }
    },
    async fetchScores() {
      try {
        let items = await this.request({
          route: 'riskScores',
          defaultErrorHandler: false,
        });
        return items;
      } catch (e) {
        this.showAlert({
          type: 'error',
          message: 'Failed to load Risk Scores',
        });
      } finally {
        this.$emit('loaded');
      }
    },
    async edit(score: Score, axe: string) {
      try {
        await this.showModal({
          type: 'HeatmapEditVectorCard',
          data: {
            saveUrl: `${this.routes.riskScores}/${score.id}`,
            vectors: this.vectors,
            scoreTitle: score.title,
            vectorPair: { x: score.heatmapX, y: score.heatmapY },
            axe: axe,
          },
        });
        this.reloadScores();
      } catch (e) {
        // User closed modal
      }
    },
    async reloadScores() {
      this.items = (await this.fetchScores()) || [];
      this.vectorIdsToVectors(this.items);
      this.loading = false;
    },
    vectorIdsToVectors(scores: Array<Score>) {
      scores.forEach(o => {
        o.heatmapX = matchIds(o.heatmapX, this.vectors);
        o.heatmapY = matchIds(o.heatmapY, this.vectors);
        // Default values are first two vectors:
        if (!o.heatmapX) {
          o.heatmapX = this.vectors[0] || {};
        }
        if (!o.heatmapY) {
          o.heatmapY = this.vectors[1] || {};
        }
      });
    },
  },
});
